import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import ReactPlayer from 'react-player/soundcloud';
import { Document, Page, pdfjs } from 'react-pdf';
import { fetchResources } from '../../api/notion';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

// Configurer le worker pour react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const RessourcesPage = () => {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadResources = async () => {
      const data = await fetchResources();
      setResources(data);
      setLoading(false);
    };
    loadResources();
  }, []);

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4">Ressources Audio-Visuelles</h2>
      {loading ? (
        <p className="text-center">Chargement...</p>
      ) : (
        <Row>
          {resources.map((resource) => (
            <Col md={4} key={resource.id} className="mb-4">
              <Card className="text-center no-border">
                {resource.image && (
                  <Card.Img
                    variant="top"
                    src={resource.image}
                    alt={resource.title}
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                )}
                <Card.Body>
                  <Card.Title>{resource.title}</Card.Title>
                  {resource.category && (
                    <Card.Subtitle className="mb-2 text-muted">
                      {resource.category}
                    </Card.Subtitle>
                  )}
                  <Card.Text>{resource.content}</Card.Text>
                  {resource.soundcloud && (
                    <div className="soundcloud-player">
                      <ReactPlayer
                        url={resource.soundcloud}
                        width="100%"
                        height="166px"
                      />
                    </div>
                  )}
                  {resource.pdfUrl && (
                    <div className="pdf-viewer mt-2">
                      <Document file={resource.pdfUrl}>
                        <Page pageNumber={1} width={300} />
                      </Document>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
      <style jsx>{`
        .card {
          border: none;
          box-shadow: none;
          background: transparent;
        }
        .soundcloud-player {
          margin-top: 10px;
        }
        .pdf-viewer {
          overflow: auto;
          max-height: 400px;
        }
      `}</style>
    </Container>
  );
};

export default RessourcesPage;